import {
    FETCH_PACE_PRO_BANDS_SUMMARY,
    FETCH_PACE_PRO_BANDS_SUMMARY_SUCCESS,
    FETCH_PACE_PRO_BANDS_SUMMARY_FAIL,
    FETCH_PACE_PRO_BANDS,
    FETCH_PACE_PRO_BANDS_SUCCESS,
    FETCH_PACE_PRO_BANDS_FAIL,
    FETCH_PACE_PRO_BAND,
    FETCH_PACE_PRO_BAND_SUCCESS,
    FETCH_PACE_PRO_BAND_FAIL,
    SAVE_PACE_PRO_BAND,
    SAVE_PACE_PRO_BAND_SUCCESS,
    SAVE_PACE_PRO_BAND_FAIL,
    UPDATE_PACE_PRO_BAND,
    UPDATE_PACE_PRO_BAND_SUCCESS,
    UPDATE_PACE_PRO_BAND_FAIL,
    SEND_PACEPRO_TO_DEVICE,
    DELETE_PACEPRO,
    DELETE_PACEPRO_SUCCESS,
    DELETE_PACEPRO_FAIL,
    FETCH_PACE_PRO_BAND_COURSE
} from 'actions/paceProBandActions.js';

// Used for updates/saves
export const NETWORKING_STATUSES = {
    FAIL: 'FAIL',
    SUCCESS: 'SUCCESS',
    SAVING: 'SAVING',
    FETCHING: 'FETCHING',
    DELETING: 'DELETING'
};

const INITIAL_STATE = {
    paceProBands: {},
    networkingStatus: NETWORKING_STATUSES.SUCCESS
};

const fetchPaceProBandSummarySuccess = (state, action) => {
    const paceProBands = {};
    // convert to this form: 'id: { paceband info }' for quick lookup
    action.paceProBandSummaries.forEach((paceProSummary) => {
        if (!paceProBands[paceProSummary.paceBandPk]) {
            paceProBands[paceProSummary.paceBandPk] = {};
        }
        paceProBands[paceProSummary.paceBandPk].paceBandSummary = paceProSummary;
    });
    return {
        ...state,
        paceProBands,
        networkingStatus: NETWORKING_STATUSES.SUCCESS
    };
};

const fetchPaceProBandSummaryFail = (state, action) => {
    return state;
};

const fetchPaceProBandsSuccess = (state, action) => {
    // convert to this form: 'id: { paceband info }' for quick lookup
    let processedPaceBands = {};
    action.paceProBands.forEach((paceProBand) => {
        processedPaceBands[paceProBand.paceBandSummary.paceBandPk] = paceProBand;
    });

    return {
        paceProBands: {
            ...state.paceProBands,
            ...processedPaceBands
        },
        networkingStatus: NETWORKING_STATUSES.SUCCESS
    };
};

const fetchPaceProBandsFail = (state, action) => {
    return state;
};

const fetchPaceProBandSuccess = (state, action) => {
    return {
        paceProBands: {
            ...state.paceProBands,
            [action.paceProBand.paceBandSummary.paceBandPk]: action.paceProBand
        },
        networkingStatus: NETWORKING_STATUSES.SUCCESS
    };
};

const fetchPaceProBandStart = (state, action) => {
    return {
        paceProBands: {
            ...state.paceProBands
        },
        networkingStatus: NETWORKING_STATUSES.FETCHING
    };
};

const savePaceProBandStart = (state) => {
    return {
        paceProBands: {
            ...state.paceProBands
        },
        networkingStatus: NETWORKING_STATUSES.SAVING
    };
};

const updatePaceProBandStart = (state) => {
    return {
        paceProBands: {
            ...state.paceProBands
        },
        networkingStatus: NETWORKING_STATUSES.SAVING
    };
};

const savePaceProBandFail = (state, action) => {
    return {
        paceProBands: {
            ...state.paceProBands
        },
        networkingStatus: NETWORKING_STATUSES.FAIL
    };
};

const updatePaceProBandFail = (state, action) => {
    return {
        paceProBands: {
            ...state.paceProBands
        },
        networkingStatus: NETWORKING_STATUSES.FAIL
    };
};

const fetchPaceProBandFail = (state, action) => {
    return {
        paceProBands: {
            ...state.paceProBands
        },
        networkingStatus: NETWORKING_STATUSES.FAIL
    };
};

const deletePaceProBandSuccess = (state, action) => {
    delete state.paceProBands[action.paceBandId];
    return {
        paceProBands: {
            ...state.paceProBands
        },
        networkingStatus: NETWORKING_STATUSES.SUCCESS
    };
};

const deletePaceProBandStart = (state) => {
    return {
        paceProBands: {
            ...state.paceProBands
        },
        networkingStatus: NETWORKING_STATUSES.DELETING
    };
};

const deletePaceProBandFail = (state, action) => {
    return {
        paceProBands: {
            ...state.paceProBands
        },
        networkingStatus: NETWORKING_STATUSES.FAIL
    };
};

const handlers = {
    [FETCH_PACE_PRO_BANDS_SUMMARY_SUCCESS]: fetchPaceProBandSummarySuccess,
    [FETCH_PACE_PRO_BANDS_SUMMARY_FAIL]: fetchPaceProBandSummaryFail,
    [FETCH_PACE_PRO_BANDS_SUCCESS]: fetchPaceProBandsSuccess,
    [FETCH_PACE_PRO_BANDS_FAIL]: fetchPaceProBandsFail,
    [FETCH_PACE_PRO_BAND_SUCCESS]: fetchPaceProBandSuccess,
    [FETCH_PACE_PRO_BAND_FAIL]: fetchPaceProBandFail,
    [SAVE_PACE_PRO_BAND_SUCCESS]: fetchPaceProBandSuccess,
    [SAVE_PACE_PRO_BAND_FAIL]: savePaceProBandFail,
    [UPDATE_PACE_PRO_BAND_SUCCESS]: fetchPaceProBandSuccess,
    [UPDATE_PACE_PRO_BAND_FAIL]: updatePaceProBandFail,
    [SAVE_PACE_PRO_BAND]: savePaceProBandStart,
    [UPDATE_PACE_PRO_BAND]: updatePaceProBandStart,
    [FETCH_PACE_PRO_BANDS_SUMMARY]: fetchPaceProBandStart,
    [DELETE_PACEPRO]: deletePaceProBandStart,
    [DELETE_PACEPRO_SUCCESS]: deletePaceProBandSuccess,
    [DELETE_PACEPRO_FAIL]: deletePaceProBandFail
};

export default function paceProBand(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}

// Actions
export function fetchPaceProBandSummaries(courseId) {
    return {
        type: FETCH_PACE_PRO_BANDS_SUMMARY,
        courseId: courseId
    };
}

export function fetchPaceProBands() {
    return {
        type: FETCH_PACE_PRO_BANDS
    };
}

export function fetchPaceProBand(paceBandId) {
    return {
        type: FETCH_PACE_PRO_BAND,
        paceBandId: paceBandId
    };
}

export function fetchCourseForPacePro(courseId) {
    return {
        type: FETCH_PACE_PRO_BAND_COURSE,
        courseId: courseId
    };
}

export function savePaceProBand(paceProBand, courseNotOwned, hasShareableEvent) {
    return {
        type: SAVE_PACE_PRO_BAND,
        paceProBand: paceProBand,
        courseNotOwned: courseNotOwned,
        hasShareableEvent: hasShareableEvent
    };
}

export function updatePaceProBand(paceBandId, paceProBand) {
    return {
        type: UPDATE_PACE_PRO_BAND,
        paceBandId: paceBandId,
        paceProBand: paceProBand
    };
}

export function sendPaceProBandToDevice(payload) {
    return {
        type: SEND_PACEPRO_TO_DEVICE,
        payload
    };
}

export function deletePacePro(paceBandId) {
    return {
        type: DELETE_PACEPRO,
        paceBandId: paceBandId
    };
}

// Getters
export const getPaceProBands = (state) => {
    const keys = Object.keys(state.paceProBand.paceProBands);
    const paceProBands = keys.map((key) => state.paceProBand.paceProBands[key]);
    return paceProBands;
};

export const getPaceProSummaries = (state, courseId) => {
    const keys = Object.keys(state.paceProBand.paceProBands);
    const paceProBandSummaries = keys.map((key) => state.paceProBand.paceProBands[key].paceBandSummary);
    if (courseId) {
        return paceProBandSummaries.filter((paceProBandSummary) => paceProBandSummary.courseId === courseId);
    }
    return paceProBandSummaries;
};

export const getRelatedPaceProSummaries = (state, courseId, paceBandPk) => {
    const keys = Object.keys(state.paceProBand.paceProBands);
    const paceProBandSummaries = keys.map((key) => state.paceProBand.paceProBands[key].paceBandSummary);
    if (courseId) {
        return paceProBandSummaries.filter(
            (paceProBandSummary) =>
                paceProBandSummary.courseId === courseId && paceProBandSummary.paceBandPk !== paceBandPk
        );
    }
    return [];
};

export const getPaceProSplits = (state, paceBandId) => {
    const paceProBand = state.paceProBand.paceProBands[paceBandId];
    return paceProBand ? paceProBand.paceBandSplits : [];
};

export const getPaceProBand = (state, paceBandId) => {
    return state.paceProBand.paceProBands[paceBandId] || {};
};

export const getPaceProNetworkStatus = (state) => {
    return state.paceProBand.networkingStatus;
};
